import { z } from 'zod/v4';

export const LinkUsersRequestSchema = z.object({
  actionId: z.string().min(1, 'Action ID is required'),
  users: z.array(
    z.object({
      userId: z.string().min(1, 'User ID is required'),
      companyId: z.string().min(1, 'Company ID is required'),
    }),
  ),
});

export type LinkUsersRequest = z.infer<typeof LinkUsersRequestSchema>;
